import React, { useState } from "react";
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import UserDetail from "../users/UserDetail";
import CreateIcon from "@mui/icons-material/Create";
import UserEdit from "../users/UserEdit";

export default function AppPurchase() {
  const [checked, setChecked] = useState(true);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const data = [
    {
      fname: "Kalli",
      lname: "John",
      username: "Kali John",
      email: "kalli@gamil.com",
      phoneno: "9898989898",
      address: "#565, Street No 54, London",
      country: "London",
      regDate: "05-11-2022",
      purdate: "05-11-2022",
    },
    {
      fname: "Kalli",
      lname: "John",
      username: "Kali John",
      email: "kalli@gamil.com",
      phoneno: "9898989898",
      address: "#565, Street No 54, London",
      country: "London",
      regDate: "05-11-2022",
      purdate: "05-11-2022",
    },
    {
      fname: "Kalli",
      lname: "John",
      username: "Kali John",
      email: "kalli@gamil.com",
      phoneno: "9898989898",
      address: "#565, Street No 54, London",
      country: "London",
      regDate: "05-11-2022",
      purdate: "05-11-2022",
    },
    {
      fname: "Kalli",
      lname: "John",
      username: "Kali John",
      email: "kalli@gamil.com",
      phoneno: "9898989898",
      address: "#565, Street No 54, London",
      country: "London",
      regDate: "05-11-2022",
      purdate: "05-11-2022",
    },
    {
      fname: "Kalli",
      lname: "John",
      username: "Kali John",
      email: "kalli@gamil.com",
      phoneno: "9898989898",
      address: "#565, Street No 54, London",
      country: "London",
      regDate: "05-11-2022",
      purdate: "05-11-2022",
    },
    {
      fname: "Kalli",
      lname: "John",
      username: "Kali John",
      email: "kalli@gamil.com",
      phoneno: "9898989898",
      address: "#565, Street No 54, London",
      country: "London",
      regDate: "05-11-2022",
      purdate: "05-11-2022",
    },
    {
      fname: "Kalli",
      lname: "John",
      username: "Kali John",
      email: "kalli@gamil.com",
      phoneno: "9898989898",
      address: "#565, Street No 54, London",
      country: "London",
      regDate: "05-11-2022",
      purdate: "05-11-2022",
    },
    {
      fname: "Kalli",
      lname: "John",
      username: "Kali John",
      email: "kalli@gamil.com",
      phoneno: "9898989898",
      address: "#565, Street No 54, London",
      country: "London",
      regDate: "05-11-2022",
      purdate: "05-11-2022",
    },
    {
      fname: "Kalli",
      lname: "John",
      username: "Kali John",
      email: "kalli@gamil.com",
      phoneno: "9898989898",
      address: "#565, Street No 54, London",
      country: "London",
      regDate: "05-11-2022",
      purdate: "05-11-2022",
    },
    {
      fname: "Kalli",
      lname: "John",
      username: "Kali John",
      email: "kalli@gamil.com",
      phoneno: "9898989898",
      address: "#565, Street No 54, London",
      country: "London",
      regDate: "05-11-2022",
      purdate: "05-11-2022",
    },
  ];
  const tableData = () => {
    return (
      <TableContainer className="tbl_mn br-24 br-btm-0 ">
        <Table className="table-design table_center">
          <TableHead>
            <TableRow className="tbl_rw">
              <TableCell className="fz-18 fw-bold">First Name</TableCell>
              <TableCell className="fz-18 fw-bold">Last Name</TableCell>
              <TableCell className="fz-18 fw-bold">Username</TableCell>
              <TableCell className="fz-18 fw-bold">Email</TableCell>
              <TableCell className="fz-18 fw-bold">Phone No</TableCell>
              <TableCell className="fz-18 fw-bold">Address</TableCell>
              <TableCell className="fz-18 fw-bold">Country</TableCell>
              <TableCell className="fz-18 fw-bold">Registered Date</TableCell>
              <TableCell className="fz-18 fw-bold">Purchase Date</TableCell>
              {/* <TableCell className='fz-18 fw-bold'>Block/ Unblock</TableCell>
							<TableCell className='fz-18 fw-bold'>Action</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, i) => {
              return (
                <TableRow key={i}>
                  <TableCell className="fz-16">{item.fname}</TableCell>
                  <TableCell className="fz-16">{item.lname}</TableCell>
                  <TableCell className="fz-16">{item.username}</TableCell>
                  <TableCell className="fz-16">{item.email}</TableCell>
                  <TableCell className="fz-16">{item.phoneno}</TableCell>
                  <TableCell className="fz-16">{item.address}</TableCell>
                  <TableCell className="fz-16">{item.country}</TableCell>
                  <TableCell className="fz-16">{item.regDate}</TableCell>
                  <TableCell className="fz-16">{item.purdate}</TableCell>
                  {/* <TableCell className='fz-16' style={{textAlign:"center"}}>
											<Switch
												checked='true'
												onChange={handleChange}
												inputProps={{ 'aria-label': 'controlled' }}
											/>
										</TableCell>
										<TableCell className='fz-16'>
											<Link to="/edituser" style={{marginRight: "8px"}}>
												<CreateIcon />
											</Link>
											<Link to="/userdetail">
												<RemoveRedEyeIcon />
											</Link>
										</TableCell> */}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "30px",
          }}
        >
          <Stack spacing={2}>
            <Pagination count={10} />
          </Stack>
        </Box>
      </TableContainer>
    );
  };

  return (
    <Box
      display="flex"
      className="box-wrapper br-24 table_bx"
      flexDirection="column"
      justifyContent="start"
    >
      <div className="heading-btn_wrapper">
        <h5 className="fz-20 fw-bold">InApp Purchases</h5>
        <Box className="table_srch">
          <TextField
            placeholder="Search here"
            InputProps={{
              startAdornment: <SearchIcon />,
            }}
          />
        </Box>
      </div>
      {tableData()}
    </Box>
  );
}
